skrilla.directive('exportToCsv',function() {
    return {
        templateUrl: 'directives/exportToCsv/exportToCsv.html',
        scope: {
            data: "=",
            dataFunction: "=",
            buttonTitle: "="

        },
        controller: function($scope, cacheService, modalService){

            $scope.open = function(){
                const csvData = typeof $scope.data === 'function' ? $scope.data() : $scope.data;
                cacheService.registerObject("exportToCsv", csvData );
                modalService.openModal("views/exportToCsvModal/exportToCsvModal.html", true, 'lg', true, true);
            }

        }
    };
});
